import React from 'react';
import ArticleStickySidebar from 'components/article-sticky-sidebar';
import PersonTeaserBlock from 'components/person-teaser-block';
import Authors from 'components/authors';
import useBreakpoints from 'hooks/use-breakpoints';
import PropTypes from 'prop-types';

const ArticleServiceBar = ({ anchorMenuHeading, authors }) => {
  const { isMobileArticleSidebar } = useBreakpoints(true);

  return (
    <div className="article-service-bar">
      {authors && isMobileArticleSidebar === false && (
        <Authors items={authors} className="article-service-bar__authors" />
      )}
      <ArticleStickySidebar
        anchorMenuHeading={anchorMenuHeading}
        authors={authors}
      />
    </div>
  );
};

ArticleServiceBar.propTypes = {
  anchorMenuHeading: PropTypes.string.isRequired,
  authors: PropTypes.arrayOf(PropTypes.exact(PersonTeaserBlock.propTypes)),
};

export default ArticleServiceBar;
